"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _style = require("./style");

var _excluded = ["children", "size", "tag"];

var _this = void 0;

var Text = _Typography["default"].Text;
/**
 * ChargeInfo.Label
 * @description 计费UI组件-表单项标题
 */

var Label = function Label(_ref) {
  (0, _newArrowCheck2["default"])(this, _this);
  var children = _ref.children,
      size = _ref.size,
      tag = _ref.tag,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var sizeMap = {
    lg: {
      color: "dark",
      size: "t2",
      lineHeight: "md",
      strong: true,
      transform: "capitalize"
    },
    md: {
      color: "dark",
      size: "t1",
      lineHeight: "lg",
      strong: false,
      transform: "capitalize"
    },
    sm: {
      color: "light",
      size: "t1",
      lineHeight: "lg",
      strong: false,
      transform: "capitalize"
    }
  };

  if (tag) {
    return /*#__PURE__*/_react["default"].createElement(Text, (0, _extends2["default"])({}, sizeMap[size], others), /*#__PURE__*/_react["default"].createElement(_style.StyledLabelText, null, children), tag);
  }

  return /*#__PURE__*/_react["default"].createElement(Text, (0, _extends2["default"])({}, sizeMap[size], others), children);
}.bind(void 0);

Label.propTypes = {
  /** 表单项标题的尺寸 */
  size: _propTypes["default"].oneOf(["sm", "md", "lg"]),

  /** 表单项标题旁的图标标注 */
  tag: _propTypes["default"].node,
  children: _propTypes["default"].node
};
Label.defaultProps = {
  size: "lg"
};
var _default = Label;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ChargeInfo/Label.js
// module id = 1716
// module chunks = 6 7 17 18